import { handleDateFilters } from '@app/pages/Clients/ClientsList/utils/handleDateFilters';
import { handleSecondClientObjectIndex } from '@app/pages/Clients/ClientsList/utils/handleSecondClientObjectIndex';

import { adaptDataToTable } from '@pages/Clients/ClientsList/utils/adaptDataToTable';
import { adaptFiltersForServer } from '@pages/Clients/ClientsList/utils/adaptFiltersForServer';
import { buildDataTree } from '@pages/Clients/ClientsList/utils/buildDataTree';
import { calculateServerFilters } from '@pages/Clients/ClientsList/utils/calculateChosenFilters';
import { calculateSelectedFiltersByClients } from '@pages/Clients/ClientsList/utils/calculateSelectedFiltersByClients';
import { clearPeriod } from '@pages/Clients/ClientsList/utils/clearPeriod';
import { defineFastDatesFilter } from '@pages/Clients/ClientsList/utils/defineFastDatesFilter';
import { generateLastMonthPeriod } from '@pages/Clients/ClientsList/utils/generateLastMonthPeriod';
import { generateLastThreeMonths } from '@pages/Clients/ClientsList/utils/generateLastThreeMonths';
import { getClientLogicalGroupIndex } from '@pages/Clients/ClientsList/utils/getClientLogicalGroupIndex';
import { getDataBeforeTargetKey } from '@pages/Clients/ClientsList/utils/getDataBeforeTargetKey';
import { getFiltersArray } from '@pages/Clients/ClientsList/utils/getFiltersArray';
import { getFilterValuesRest } from '@pages/Clients/ClientsList/utils/getFilterValuesRest';
import { hideFilterBlock } from '@pages/Clients/ClientsList/utils/hideFilterBlock';

export {
  adaptDataToTable,
  buildDataTree,
  calculateServerFilters,
  handleSecondClientObjectIndex,
  generateLastMonthPeriod,
  generateLastThreeMonths,
  adaptFiltersForServer,
  hideFilterBlock,
  defineFastDatesFilter,
  getDataBeforeTargetKey,
  getFilterValuesRest,
  clearPeriod,
  getClientLogicalGroupIndex,
  getFiltersArray,
  calculateSelectedFiltersByClients,
  handleDateFilters,
};
